<template>
  <div class="awardContainer"></div>
</template>

<script>
export default {
  props: {
    awardData: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="less" scoped>
.awardContainer {
  width: 100%;
  height: 100%;
  background: center / cover no-repeat
    url('../../assets/images/lalamove-no-prize.png');
}
</style>
